import { useDispatch, useSelector } from "react-redux";
import { saveRowError, saveCellErrors } from "../context/rowErrorsReducer";
import { saveError } from "../context/errorReducer";
import { useValidation } from "./use_validation";

export const useFileErrors = () => {
    const dispatch = useDispatch();
    const rowErrors = useSelector(state => state.rowErrors || {});
    const { validateColumn } = useValidation();

    const saveErrors = (file) => {
        dispatch(saveError(null));
        let anyError = false;

        file.forEach((row, index) => {
            let hasError = false;
            const cellErrors = {};
            Object.entries(row).forEach(([columnName, columnValue]) => {
                const errors = validateColumn(columnName, columnValue, row);
                if (errors.length > 0) {
                    hasError = true;
                    cellErrors[columnName] = errors;
                }
            });
            if (rowErrors[index]?.hasError !== hasError) {
                dispatch(saveRowError(index, hasError));
            }
            const prevCellErrors = rowErrors[index]?.cellErrors || {};
            const cellErrorsChanged = JSON.stringify(prevCellErrors) !== JSON.stringify(cellErrors);
            if (cellErrorsChanged) {
                dispatch(saveCellErrors(index, cellErrors));
            }
            if (hasError) anyError = true;
        });
        if (anyError) {
            dispatch(saveError(true));
        }
    }
    return { saveErrors }
}
